export default "__VITE_ASSET__ClZEeyTg__"